import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import coursesApi from "@/services/api/coursesApi";
import CourseDetails from "@/components/CourseDetails.vue";
import type { ICoursePreview } from "@/types/entities/ICoursePreview";
import routesName from "@/utils/constants/routesName";
import { useRoute, useRouter } from "vue-router";
import { event } from "vue-gtag";


export default /*#__PURE__*/_defineComponent({
  __name: 'CourseDetailsView',
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();
const router = useRouter();
const courseId = computed(() => Number(route.params.id));
const { inReview } = route.query;

const courseData = ref<ICoursePreview>();
const fetching = ref<boolean>(true);
const getCourseData = (): void => {
  fetching.value = true;
  const apiMethod =
    inReview && inReview === "true"
      ? coursesApi.getReviewById
      : coursesApi.getPreviewById;
  apiMethod(courseId.value)
    .then((res) => {
      courseData.value = res.data.data;
      event("view_course", {
        course_id: res.data.data?.id,
        value: 1,
      });
    })
    .catch((e) => {
      if (e.response?.status === 404) {
        router.push({ name: routesName.notFound });
      }
    })
    .finally(() => {
      fetching.value = false;
    });
};
getCourseData();

const __returned__ = { route, router, courseId, inReview, courseData, fetching, getCourseData, computed, ref, get coursesApi() { return coursesApi }, CourseDetails, get routesName() { return routesName }, get useRoute() { return useRoute }, get useRouter() { return useRouter }, get event() { return event } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})